<template>
  <v-container fluid fill-height class="pa-0" ref="container">
    <v-layout class="ma-0 pa-0" row>
      <div ref="infoBubbleOFRef">
        <info-bubble-polygon-name
          v-if="showOfficialFenceName"
          :info="infoOfficialFenceSelected"
          @closeBubble="showOfficialFenceName = false"
        />
      </div>
      <!-- CODE & LICENSE PLATE -->
      <v-flex
        v-if="!showLoadingVehicleData  && allDataLoading"
        class="info-absolute"
        :style="showClearPolygons ? 'top:100px' : 'top:82px'"
      >
        <v-card color="grey darken-4">
          <v-layout px-2 align-center>
            <v-flex>
              <v-avatar color="grey" size="28">
                <v-icon
                  v-if="
                    vehicleTypes === null &&
                    selectedVehicle !== null &&
                    lastPositionsInit.lenght !== 0
                  "
                  dark
                >
                  hourglass_top
                </v-icon>
                <v-icon v-else dark>
                  {{
                    vehicleTypes.get(selectedVehicle.vehicleType) === 'MOTOCICLETA'
                      ? 'two_wheeler'
                      : 'directions_car'
                  }}
                </v-icon>
              </v-avatar>
            </v-flex>
            <v-flex pt-1 pl-3>
              <b class="caption">Código/Sigla</b>
              <p style="margin-top:-6px;">{{ selectedVehicle.code }}</p>
            </v-flex>
            <v-flex pt-1 pl-3>
              <b class="caption">Placa</b>
              <p style="margin-top:-6px;">{{ selectedVehicle.licensePlate }}</p>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <!-- ROUTE PLAYER -->
      <v-flex
        v-if="!showLoadingVehicleData  && allDataLoading && showRoutePlayer"
        class="player-absolute"
      >
        <route-player
          :routeEvents="eventsBlocks"
          @closeRoutePlayer="closeRoutePlayer"
          @processCurrentEventFromPlayer="processCurrentEventFromPlayer"
        />
      </v-flex>
      <!-- OFFICIAL FENCES -->
      <v-flex v-if="!showLoadingVehicleData  && allDataLoading" class="btn-absolute">
        <official-zones />
      </v-flex>
      <!-- DIALOG LOADING VEHICLE DATA -->
      <v-dialog
        v-model="showLoadingVehicleData"
        max-width="300"
        persistent>
        <v-card
          class="text-xs-center py-2"
          height="200">
          <h5 class="mt-3">
            Cargando Datos del Vehículo
          </h5>
          <v-progress-circular
            class="mt-5"
            :size="50"
            color="primary"
            indeterminate>
          </v-progress-circular>
        </v-card>
      </v-dialog>
      <!-- DIALOG LOADING ALL DATA -->
      <v-dialog
        v-if="!allDataLoading"
        v-model="dialogAllData"
        max-width="300"
        persistent>
        <v-card
          class="text-xs-center py-2"
          height="200">
          <h5 class="mt-3">
            Cargando Datos Globales
          </h5>
          <v-progress-circular
            class="mt-5"
            :size="50"
            color="primary"
            indeterminate>
          </v-progress-circular>
        </v-card>
      </v-dialog>
      <!-- MAP -->
      <v-flex class="container-map" v-if="!showLoadingVehicleData && allDataLoading">
        <gmap-map
          class="AppVehicleViewer_map"
          :center="center"
          ref="VehicleViewerMap"
          :options="mapOptions">
          <!-- <GmapPolyline
            v-if="positions.hasOwnProperty('data')" ref="polyLine"
            :path="positions.data"
            :options="polylineOptions"/> -->
          <GmapPolyline
            v-for="(events, index) in eventsBlocks"
            :key="index"
            :ref="'polyLine'+index"
            :path="events"
            :options="polylineOptions[index]"
          />
           <!-- OFFICIAL ZONES -->
          <gmap-polygon
            v-for="(path, index) in neighborhoodsPath"
            :key="`${index}N`"
            :paths="path"
            :options="polygonOptions1"
            @click="showPolygonName($event, {index, key: 'neighborhoods'})"
          />

          <gmap-polygon
            v-for="(path, index) in communesPath"
            :key="`${index}C`"
            :paths="path"
            :options="polygonOptions2"
            @click="showPolygonName($event, {index, key: 'communes'})"
          />

          <gmap-polygon
            v-for="(path, index) in quadrantsPath"
            :key="`${index}Q`"
            :paths="path"
            :options="polygonOptions3"
            @click="showPolygonName($event, {index, key: 'quadrants'})"
          />

          <gmap-polygon
            v-for="(path, index) in stationsPath"
            :key="`${index}S`"
            :paths="path"
            :options="polygonOptions4"
            @click="showPolygonName($event, {index, key: 'stations'})"
          />

          <gmap-polygon
            v-for="(path, index) in empasPath"
            :key="`${index}E`"
            :paths="path"
            :options="polygonOptions7"
            @click="showPolygonName($event, {index, key: 'empas'})"
          />

          <gmap-polygon
            v-for="(path, index) in districtsPath"
            :key="`${index}D`"
            :paths="path"
            :options="polygonOptions5"
            @click="showPolygonName($event, {index, key: 'districts'})"
          />

          <gmap-polygon
            v-for="(path, index) in firefightersPath"
            :key="`${index}F`"
            :paths="path"
            :options="polygonOptions6"
            @click="showPolygonName($event, {index, key: 'firefighters'})"
          />

          <GmapMarker
            v-if="selectedVehicle !== null"
            :position="selectedVehicle.location"
            :icon="{ url: marker()}"
          />
          <GmapMarker
            v-if="showMarkers !== null"
            :position="selectedPosition"
            :icon="{
              url: markerEvent(selectedPosition),
              scaledSize: {width: 32, height: 32}
            }"
          />
            <!-- v-if="showMarkers && positions.hasOwnProperty('data')" -->
          <!-- MARKERS EVENT TYPE 53  -->
            <!-- v-if="showMarkers" -->
          <GmapMarker
            v-for="(event, index) in filteredEvents"
            :key="event.id"
            :position="event"
            :icon="{
              path: 0,
              scale: 5.5,
              fillColor: '#F50057',
              fillOpacity: 0.9,
              strokeWeight: 1.5
            }"
            @click="handleClickMarker($event, event, index)"
          />
          <!-- MARKER ALL EVENTS LOADED -->
          <GmapMarker
            v-if="showMarkersALL && positions.hasOwnProperty('data')"
            v-for="(position, index) in positions.data"
            :key="`${position.id}-${String(index)}`"
            :position="position"
            :icon="{
              path: 0,
              scale: 4,
              fillColor: '#FB8C00',
              fillOpacity: 0.8,
              strokeWeight: 0.1
            }"
            @click="handleClickMarker($event, position, index)"
          />
        </gmap-map>
      </v-flex>
      <!-- BIG ICON LOADING -->
      <v-flex v-else class="text-xs-center" pt-5>
        <v-avatar
          size="400px"
          color="grey darken-4">
          <v-icon size="280px" color="grey darken-3">cloud_download</v-icon>
        </v-avatar>
      </v-flex>
      <!-- RIGHT SIDE MENU -->
      <v-flex class="container-side" v-if="!showLoadingVehicleData  && allDataLoading">
        <v-tabs
          v-model="tab"
          color="primary"
          icons-and-text
          grow>
          <v-tabs-slider color="white"></v-tabs-slider>
          <v-tab href="#tab-1">
            Info Vehículo
            <v-icon>directions_car</v-icon>
          </v-tab>

          <v-tab href="#tab-2">
            Historial/Eventos
            <v-icon>history</v-icon>
          </v-tab>

          <!-- <v-tab-items> -->
            <!-- TAB 1 CONTENT-->
            <v-tab-item value="tab-1">
              <v-card v-if="selectedVehicle!==null" color="grey darken-4" width="390" class="margin-bottom-1">
                <v-progress-linear
                  v-if="$loading.isLoading('loading more positions') || $loading.isLoading(`fetchingPositionsVehicle${selectedVehicle.id}`)"
                  class="margin-2"
                  color="blue"
                  indeterminate/>

                <v-flex class="text-xs-center" pt-3>
                  <v-flex>
                    <h2>Información del Vehículo</h2>
                  </v-flex>
                </v-flex>
                <!-- INFO VEHICLE -->
                <v-flex py-4 d-flex>
                  <v-flex xs4 class="text-xs-center" pt-1>
                    <v-avatar color="grey">
                      <v-icon
                        v-if="
                          vehicleTypes === null &&
                          selectedVehicle !== null &&
                          lastPositionsInit.lenght !== 0
                        "
                        dark
                        large
                      >
                        hourglass_top
                      </v-icon>
                      <v-icon v-else dark large>
                        {{
                          vehicleTypes.get(selectedVehicle.vehicleType) === 'MOTOCICLETA'
                            ? 'two_wheeler'
                            : 'directions_car'
                        }}
                      </v-icon>
                    </v-avatar>
                    <v-flex pt-2>
                      <v-icon
                        size="21"
                        :color="stateColor(selectedVehicle).color">
                        lens
                      </v-icon>
                      <v-flex class="stopped-time-style">
                        <!-- {{ infoStateVehicle }} -->
                        <!-- TIME -->
                        <v-flex>
                          <v-flex class="subtitle-1">
                            <v-icon color="grey" size="12px">access_time</v-icon>
                            Tiempo detenido
                          </v-flex>
                          <v-flex d-inline-flex align-center>
                            <v-flex>
                              <b>
                                <v-flex class="h7">
                                  {{ stateColor(selectedVehicle).amountStoppedTime }}
                                </v-flex>
                              </b>
                            </v-flex>
                            <v-flex v-if="stateColor(selectedVehicle).amountStoppedTime !== 'Estático'" pl-1>
                              minutos
                            </v-flex>
                          </v-flex>
                        </v-flex>
                        <!-- STOPPED CONDITION -->
                        <v-flex pt-2>
                          <v-flex class="subtitle-1">
                            <v-icon color="grey" size="12px">event</v-icon>
                            Inicio estacionaria
                          </v-flex>
                          <v-flex d-inline-flex>
                            <v-flex>
                              <b>
                                <v-flex class="h7">
                                  {{
                                    stateColor(selectedVehicle).stoppedSince === ''
                                      ? 'NA'
                                      : stateColor(selectedVehicle).stoppedSince  | filterFullDate
                                  }}
                                </v-flex>
                              </b>
                            </v-flex>
                          </v-flex>
                        </v-flex>

                        <v-flex pt-2>
                          <v-flex class="subtitle-1">
                            <v-icon color="grey" size="12px">event</v-icon>
                            Cambio a estado {{ stateColor(selectedVehicle).indexState }}
                          </v-flex>
                          <v-flex d-inline-flex>
                            <v-flex>
                              <b>
                                <v-flex class="h7">
                                  {{ stateColor(selectedVehicle).changeStateAt === 'Invalid date' ? 'NA' : stateColor(selectedVehicle).changeStateAt | filterFullDate }}
                                </v-flex>
                              </b>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                      </v-flex>

                    </v-flex>
                  </v-flex>
                  <v-flex xs8 pl-2 pt-2>
                    <v-flex pt-1>
                      <p><b>Código/Sigla:</b>  {{ selectedVehicle.code }}</p>
                    </v-flex>
                    <v-flex pt-1>
                      <p><b>Placa:</b>  {{ selectedVehicle.licensePlate }}</p>
                    </v-flex>
                    <v-flex pt-1>
                      <p><b>ID dispositivo:</b>  {{ selectedVehicle.currentDevice.esn }}</p>
                    </v-flex>
                    <v-flex pt-1>
                      <p><b>Tipo de vehículo:</b>
                        {{
                          vehicleTypes === null &&
                          selectedVehicle !== null &&
                          lastPositionsInit.lenght !== 0
                            ? 'Cargando...'
                            : vehicleTypes.get(selectedVehicle.vehicleType)
                        }}
                      </p>
                    </v-flex>
                    <v-flex pt-1>
                      <p><b>Marca:</b>  {{  selectedVehicle.brand }}</p>
                    </v-flex>
                    <v-flex pt-1>
                      <p><b>Agencia:</b>  {{ (agenciesMap !== null && selectedVehicle !== null && lastPositionsInit.lenght !== 0 && selectedVehicle.agencyId) ? agenciesMap.get(selectedVehicle.agencyId).name : '' }}</p>
                    </v-flex>
                    <!-- VEHICLE CONDITION -->
                    <v-flex pt-1>
                      <p>
                        <b>Condición Vehículo:</b>
                        {{ selectedVehicle.status.translatedName }}
                      </p>
                    </v-flex>
                    <!-- VEHICLE IN MISSION -->
                    <v-flex pt-1>
                      <p>
                        <b>Misión:</b>
                        {{
                          selectedVehicle.inMission !== undefined ?
                          inMissionStatesMap.get(selectedVehicle.inMission) :
                          'Cargando...'
                        }}
                      </p>
                    </v-flex>
                  </v-flex>
                </v-flex>
                <v-divider></v-divider>
                <!-- LAST POSITION -->
                <v-flex class="text-xs-center">
                  <v-flex pt-3 pb-2 d-inline-flex align-center>
                    <v-flex>
                      <img :src="marker()" alt="LPMarker" height="40">
                    </v-flex>
                    <v-flex pl-2>
                      <h2>Última Posición</h2>
                    </v-flex>
                  </v-flex>
                </v-flex>

                <v-flex d-flex>
                  <v-flex class="text-xs-left" pl-5 pb-2>
                    <p><b>Lat:</b> {{ selectedVehicle !== null ? selectedVehicle.location.lat : '' }}</p>
                    <p><b>Lng:</b> {{ selectedVehicle !== null ? selectedVehicle.location.lng : '' }}</p>
                  </v-flex>

                  <v-flex>
                    <v-flex>
                      <v-flex d-inline-flex align-center>
                        <v-flex>
                          <v-icon size="21" color="grey">event</v-icon>
                        </v-flex>
                        <v-flex pl-2>
                          <p>{{ selectedVehicle.location.time | filterDate }}</p>
                        </v-flex>
                      </v-flex>
                    </v-flex>

                    <v-flex>
                      <v-flex d-inline-flex align-center pb-2>
                        <v-flex>
                          <v-icon size="21" color="grey">access_time</v-icon>
                        </v-flex>
                        <v-flex pl-2>
                          <p>{{ selectedVehicle.location.time | filterTime }}</p>
                        </v-flex>
                      </v-flex>
                    </v-flex>
                  </v-flex>
                </v-flex>

                <v-flex d-inline-flex pl-5 pb-3 align-center>
                  <v-flex class="text-xs-center icon-address">
                    <v-icon size="21" color="grey">near_me</v-icon>
                  </v-flex>
                  <v-flex pr-5>
                    {{ addressLastPosition }}
                  </v-flex>
                </v-flex>

                <v-divider></v-divider>
                <!-- METADATA VEHICLE -->
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <v-flex class="text-xs-center"  pl-3 slot="header">
                      <h2>Más Información</h2>
                    </v-flex>
                    <v-card color="grey darken-4" class="pl-5">
                      <v-card-text>
                        <p><b>Vel:</b>
                          {{ selectedVehicle !== null ? selectedVehicle.location.speed : '' }} Km/h
                        </p>
                        <p><b>Evento:</b>
                          {{ selectedVehicle !== null ? eventTypeName(selectedVehicle.location.eventType) : '' }}
                        </p>
                        <p><b>Rumbo:</b>
                          {{ selectedVehicle !== null ? selectedVehicle.location.direction : '' }}˚
                        </p>
                        <p><b>Señal:</b>
                          {{ gpsValid }}
                        </p>
                        <p><b>Batería Vehículo:</b>
                          {{
                            selectedVehicle.mainBatteryVoltage
                              ? selectedVehicle.mainBatteryVoltage
                              : selectedVehicle.location.metadata.mainBatteryVoltage
                          }} V
                        </p>
                        <p><b>Satélites:</b>
                          {{
                            selectedVehicle.numberOfSatellites
                              ? selectedVehicle.numberOfSatellites
                              : selectedVehicle.location.metadata.numberOfSatellites
                          }}
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-divider></v-divider>
                <!-- ZONES -->
                <v-flex class="text-xs-center">
                  <v-flex pt-3 pb-2 d-inline-flex>
                    <v-flex>
                      <v-icon size="32" color="primary">my_location</v-icon>
                    </v-flex>
                    <v-flex pl-2>
                      <h2>Zonas</h2>
                    </v-flex>
                  </v-flex>
                </v-flex>

                <v-flex d-flex align-center py-2 pl-5>
                  <v-flex v-if="loadingPlaces" class="text-xs-center" pb-5>
                    <v-progress-circular
                      class="mt-2"
                      :size="32"
                      color="primary"
                      indeterminate>
                    </v-progress-circular>
                    <v-flex class="caption" pt-3>Actualizando Info Zonas</v-flex>
                  </v-flex>
                  <v-flex v-else class="text-xs-left" pb-3>
                    <p v-if="!gobernacionZones"><b>Barrio:</b>  {{ neighborhood }}</p>
                    <p v-if="!gobernacionZones"><b>Comuna:</b> {{ commune }}</p>
                    <p><b>Cuadrante:</b> {{ quadrant }}</p>
                    <p><b>Estación:</b> {{ station }}</p>
                    <p v-if="!gobernacionZones"><b>Distrito:</b> {{ district }}</p>
                    <p v-if="!gobernacionZones"><b>Bomberos:</b> {{ firefightersDivision }}</p>
                    <p><b>Municipio:</b> {{ municipality }}</p>
                  </v-flex>
                </v-flex>
              </v-card>
            </v-tab-item>

            <!-- TAB 2 CONTENT-->
            <v-tab-item value="tab-2">
              <!-- HISTORIAL -->
              <v-card v-if="selectedVehicle!==null" color="grey darken-4" width="390" class="margin-bottom-1">
                <v-flex class="text-xs-center background-1" pt-3>
                  <v-flex>
                    <h2>Historial</h2>
                  </v-flex>
                  <!-- CLEAR FILTER HISTORY BUTTON -->
                  <v-flex py-3 px-5 v-if="!!dates[0]">
                    <v-btn
                      v-if="showClearHistoryBtn"
                      :disabled="dates.length === 0"
                      color="error"
                      depressed
                      block
                      @click="handleClearFilters">
                      <v-icon left>clear</v-icon>
                      Limpiar Historial Cargado
                    </v-btn>
                  </v-flex>
                  <!-- [1] HISTORIAL 1 -->
                  <v-flex>
                    <v-flex pb-3>
                      <v-flex px-4>
                        <!-- DATE INTERVAL FOR DATE1 & DATE2 -->
                        <v-flex>
                          <v-menu
                            :disabled="eventsLoaded"
                            lazy
                            ref="menu"
                            v-model="menu"
                            transition="scale-transition"
                            :close-on-content-click="false"
                            :return-value.sync="dates"
                            offset-x
                            left
                            full-width
                            origin="top right"
                            nudge-top="-15"
                            color="white">
                            <template v-slot:activator="{ on }">
                              <v-combobox
                                v-model="dates"
                                multiple
                                chips
                                small-chips
                                label="Escoger el día o rango de días"
                                prepend-icon="event"
                                readonly
                                color="white"
                                v-on="on"
                                :disabled="eventsLoaded"
                              ></v-combobox>
                            </template>
                            <v-date-picker
                              v-model="dates"
                              multiple
                              no-title
                              scrollable
                              locale="es-sp"
                              color="blue accent-3"
                              :first-day-of-week="1"
                              :allowed-dates="allowedDates"
                            >
                              <!-- @input="changesInDates" -->
                              <v-spacer></v-spacer>
                              <v-btn color="error" @click="menu = false">Cancelar</v-btn>
                              <v-btn color="primary" @click="$refs.menu.save(dates)">Aceptar</v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <!-- SELECT TIMES DATE 1-->
                        <v-flex v-if="dates.length > 0">
                          <!-- TIME 1 DATE 1 -->
                          <v-flex class="container-date-1" py-2 d-inline-flex px-5 align-center>
                            <v-flex>
                              <v-icon>event</v-icon>
                            </v-flex>
                            <v-flex pl-1>
                              Fecha Inicial:
                            </v-flex>
                            <v-flex class="style-date-h" pl-2>
                              {{ dates[0] | moment("DD/MM/YYYY") }}
                            </v-flex>
                          </v-flex>
                          <!-- TIME 1 DATE 1 MENU -->
                          <v-flex>
                            <v-menu
                              :disabled="eventsLoaded"
                              ref="time1Date1Menu"
                              class="mx-1"
                              lazy
                              :close-on-content-click="false"
                              v-model="time1Date1Menu"
                              transition="scale-transition"
                              offset-x
                              left
                              full-width
                              allow-overflow
                              min-width="290px"
                              origin="top right"
                              nudge-top="300"
                              nudge-left="-10"
                              :return-value.sync="time1Date1"
                            >
                              <v-text-field
                                :disabled="eventsLoaded"
                                slot="activator"
                                label="Escoger una hora"
                                single-line
                                v-model="time1Date1"
                                prepend-icon="av_timer"
                                readonly
                                hide-details
                                color="white"
                              />
                              <v-time-picker
                                v-model="time1Date1"
                                format="24hr"
                                scrollable
                                color="teal darken-1"
                                header-color="grey darken-4"
                                :allowed-minutes="allowedMinutesTime1Date1"
                                @click:hour="clickedHourTime1Date1"
                              >
                                <!-- @change="$refs.time1Date1Menu.save(time1Date1)" -->
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="error"
                                  @click="time1Date1Menu = false"
                                >
                                  Cancelar
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  @click="saveTime1Date1"
                                >
                                  Aceptar
                                </v-btn>
                              </v-time-picker>
                            </v-menu>
                          </v-flex>
                          <!-- TIME 2 DATE 1 MENU -->
                          <v-flex v-if="time1Date1 && !dates[1]">
                            <v-menu
                              :disabled="eventsLoaded"
                              ref="time2Date1Menu"
                              class="mx-1"
                              lazy
                              :close-on-content-click="false"
                              v-model="time2Date1Menu"
                              transition="scale-transition"
                              offset-x
                              left
                              full-width
                              min-width="290px"
                              origin="top right"
                              nudge-top="-15"
                              :return-value.sync="time2Date1"
                            >
                              <v-text-field
                                :disabled="eventsLoaded"
                                slot="activator"
                                label="Escoger una hora"
                                single-line
                                v-model="time2Date1"
                                prepend-icon="av_timer"
                                readonly
                                hide-details
                                color="white"
                              />
                              <v-time-picker
                                v-model="time2Date1"
                                format="24hr"
                                scrollable
                                color="red darken-1"
                                header-color="grey darken-4"
                                :allowed-hours="allowedHoursTime2Date1"
                                :allowed-minutes="allowedMinutesTime2Date1"
                              >
                                <!-- @input="changesTime2Date1" -->
                                <!-- @change="$refs.time2Date1Menu.save(time2Date1)" -->
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="error"
                                  @click="time2Date1Menu = false"
                                >
                                  Cancelar
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  @click="$refs.time2Date1Menu.save(time2Date1)"
                                >
                                  Aceptar
                                </v-btn>
                              </v-time-picker>
                            </v-menu>
                          </v-flex>
                        </v-flex>
                        <!-- SELECT TIME DATE 2-->
                        <v-flex v-if="!!dates[1]" pt-4>
                          <!-- TIME 1 DATE 2 -->
                          <v-flex
                            class="container-date-2"
                            py-2
                            d-inline-flex
                            px-5
                            align-center
                          >
                            <v-flex>
                              <v-icon>event</v-icon>
                            </v-flex>
                            <v-flex pl-1>
                              Fecha Final:
                            </v-flex>
                            <v-flex class="style-date-h" pl-2>
                              {{ dates[1] | moment("DD/MM/YYYY") }}
                            </v-flex>
                          </v-flex>
                          <!-- MENU TIME 1 DATE 2 -->
                          <v-flex>
                            <v-menu
                              :disabled="eventsLoaded"
                              ref="time1Date2Menu"
                              class="mx-1"
                              lazy
                              :close-on-content-click="false"
                              v-model="time1Date2Menu"
                              transition="scale-transition"
                              offset-x
                              left
                              full-width
                              allow-overflow
                              min-width="290px"
                              origin="top right"
                              nudge-top="300"
                              nudge-left="-10"
                              :return-value.sync="time1Date2"
                            >
                              <v-text-field
                                :disabled="eventsLoaded"
                                slot="activator"
                                label="Escoger una hora"
                                single-line
                                v-model="time1Date2"
                                prepend-icon="av_timer"
                                readonly
                                hide-details
                                color="white"
                              />
                              <v-time-picker
                                v-model="time1Date2"
                                format="24hr"
                                scrollable
                                color="red darken-1"
                                header-color="grey darken-4"
                              >
                                <!-- @change="$refs.time1Date2Menu.save(time1Date2)" -->
                                <v-spacer></v-spacer>
                                <v-flex class="text-xs-center">
                                  <v-btn
                                    color="error"
                                    @click="time1Date2Menu = false"
                                  >
                                    Cancelar
                                  </v-btn>
                                  <v-btn
                                    color="primary"
                                    @click="$refs.time1Date2Menu.save(time1Date2)"
                                  >
                                    Aceptar
                                  </v-btn>
                                </v-flex>
                              </v-time-picker>
                            </v-menu>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                    </v-flex>
                  </v-flex>
                  <!-- APPLY BUTTON -->
                  <v-flex py-3 px-5>
                    <v-btn
                      v-if="!eventsLoaded"
                      color="primary"
                      depressed
                      block
                      :disabled="allowRequestHistory"
                      :loading="$loading.isLoading(`fetchingPositionsVehicle${selectedVehicle.id}`)"
                      @click="recordOfVehicleEvents"
                    >
                      <v-icon left>find_replace</v-icon>
                      Cargar Historial
                    </v-btn>
                  </v-flex>
                </v-flex>
                <v-divider></v-divider>
                <!-- PLAY ROUTE BUTTON -->
                <v-flex py-3 px-5>
                  <v-btn
                    v-if="eventsLoaded && !showRoutePlayer"
                    color="primary"
                    depressed
                    block
                    :disabled="eventsBlocks[0].length === 0"
                    @click="openRoutePlayer"
                  >
                    <v-icon left>smart_display</v-icon>
                    Reproductor de Eventos
                  </v-btn>
                  <v-btn
                    v-else-if="eventsLoaded && showRoutePlayer"
                    color="error"
                    depressed
                    block
                    @click="closeRoutePlayer"
                  >
                    <v-icon left>play_disabled</v-icon>
                    Cerrar Reproductor de Eventos
                  </v-btn>
                </v-flex>
                <!-- EVENTS -->
                <v-flex v-if="showPointsSection && !showRoutePlayer">
                  <v-flex class="text-xs-center" pt-3 pb-1>
                    <v-flex>
                      <h2>Eventos</h2>
                    </v-flex>
                  </v-flex>
                  <v-flex d-inline-flex align-center>
                    <v-flex pl-3>
                      <v-radio-group v-model="radioGroupEvents">
                        <v-radio
                          v-for="(n, index) in eventsRadio"
                          :key="index"
                          :label="n"
                          :value="n"
                          color="primary"
                          @change="showMarkersChange"
                        ></v-radio>
                      </v-radio-group>
                      <!-- <v-checkbox
                        label="Mostrar eventos"
                        hide-details
                        v-model="showMarkers"
                        color="primary">
                      </v-checkbox> -->
                    </v-flex>
                    <!-- LOAD MORE POSITIONS -->
                    <v-flex pl-3 pt-3>
                      <v-btn
                        :disabled="
                          positions.hasOwnProperty('links') &&
                          positions.links.next === null
                        "
                        color="primary"
                        small
                        :loading="$loading.isLoading('loading more positions')"
                        @click="loadMorePositions"
                      >
                          <v-icon left>autorenew</v-icon>
                          Más Eventos...
                        </v-btn>
                    </v-flex>
                  </v-flex>
                  <!-- SELECTED POSITION INFO -->
                  <v-flex px-3 pt-3 pb-2>
                    <v-flex v-if="selectedPosition !== null">
                      <v-flex pb-2>
                        <h4 class="text-xs-center">Evento Seleccionado</h4>
                      </v-flex>

                      <v-flex d-flex align-center pt-2>
                        <v-flex d-flex align-center>
                          <v-flex xs4 pb-1>
                            <img :src="markerEvent(selectedPosition)" alt="LPMarker" height="32">
                            <!-- <v-icon large color="blue lighten-2">place</v-icon> -->
                          </v-flex>
                          <v-flex class="text-xs-left">
                            <p><b>Lat:</b>
                              {{ selectedPosition.lat }}
                            </p>
                            <p><b>Lng:</b>
                              {{ selectedPosition.lng }}
                            </p>
                            <p><b>Vel:</b>
                              {{ selectedPosition.speed }} Km/h
                            </p>
                            <p><b>Señal:</b>
                              {{ selectedPosition.metadata.GPSValid ? 'Con Señal' : 'Sin Señal' }}
                            </p>
                            <p><b>Batería Vehículo:</b>
                              {{ selectedPosition.metadata.mainBatteryVoltage }} V
                            </p>
                            <p><b>Satélites:</b>
                              {{ selectedPosition.metadata.numberOfSatellites }}
                            </p>
                          </v-flex>
                        </v-flex>

                        <v-flex>
                          <v-flex>
                            <v-flex d-inline-flex align-center>
                              <v-flex>
                                <v-icon size="21" color="grey">event</v-icon>
                              </v-flex>
                              <v-flex pl-2>
                                <p>{{ selectedPosition.time | filterDate }}</p>
                              </v-flex>
                            </v-flex>
                          </v-flex>

                          <v-flex>
                            <v-flex d-inline-flex align-center>
                              <v-flex>
                                <v-icon size="21" color="grey">access_time</v-icon>
                              </v-flex>
                              <v-flex pl-2>
                                <p>{{ selectedPosition.time | filterTime }}</p>
                              </v-flex>
                            </v-flex>
                          </v-flex>

                          <v-flex>
                            <p><b>Rumbo:</b>
                              {{ selectedPosition.direction }}˚
                            </p>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                    </v-flex>
                  </v-flex>
                </v-flex>
                <!-- INFO POINTS -->
                <v-flex
                  v-else-if="!showPointsSection"
                  pb-2>
                  <v-flex class="text-xs-center" pt-3 pb-2>
                      <h2>Eventos</h2>
                  </v-flex>
                  <v-flex
                    class="text-xs-center">
                    <v-icon x-large color="grey">not_interested</v-icon>
                    <p>No hay información disponible</p>
                  </v-flex>
                </v-flex>
                <v-divider></v-divider>
                <!-- TIME LINE EVENTS -->
                <v-flex v-if="eventsBlocks.length > 0 && eventsBlocks[0].length > 0" pl-3>
                  <v-timeline dense>
                    <v-slide-x-reverse-transition
                      group
                      hide-on-leave
                    >
                      <v-timeline-item
                        v-for="(item, index) in eventsBlocks"
                        :key="index"
                        color="primary"
                        small
                        fill-dot
                      >
                        <!-- <v-btn
                          color="primary"
                          @click="blockSelected(index)">
                          Resaltar en Mapa
                        </v-btn> -->
                        <v-flex d-inline-flex align-center>
                          <v-flex>
                            <h2>{{ index + 1 }}</h2>
                          </v-flex>
                          <v-flex pl-3>
                            <v-flex pl-2 mb-2>
                              <v-flex>
                                <v-flex d-inline-flex align-center>
                                  <v-flex>
                                    <v-icon size="21" color="grey">event</v-icon>
                                  </v-flex>
                                  <v-flex pl-2>
                                    <h6>{{ item[0].time | filterDate }}</h6>
                                  </v-flex>
                                </v-flex>
                              </v-flex>

                              <v-flex>
                                <v-flex d-inline-flex align-center pb-2>
                                  <v-flex>
                                    <v-icon size="21" color="grey">access_time</v-icon>
                                  </v-flex>
                                  <v-flex pl-2>
                                   <h6>{{ item[0].time | filterTime }}</h6>
                                  </v-flex>
                                </v-flex>
                              </v-flex>
                            </v-flex>

                            <v-icon class="pl-5">arrow_downward</v-icon>

                            <v-flex pl-2 mt-2>
                              <v-flex>
                                <v-flex d-inline-flex align-center>
                                  <v-flex>
                                    <v-icon size="21" color="grey">event</v-icon>
                                  </v-flex>
                                  <v-flex pl-2>
                                    <h6>{{ item[item.length - 1].time | filterDate }}</h6>
                                  </v-flex>
                                </v-flex>
                              </v-flex>

                              <v-flex>
                                <v-flex d-inline-flex align-center pb-2>
                                  <v-flex>
                                    <v-icon size="21" color="grey">access_time</v-icon>
                                  </v-flex>
                                  <v-flex pl-2>
                                    <h6>{{ item[item.length - 1].time | filterTime }}</h6>
                                  </v-flex>
                                </v-flex>
                              </v-flex>
                            </v-flex>

                            <v-flex class="little-text" pl-2 pt-2>
                              Cantidad de eventos: {{ item.length }}
                            </v-flex>
                          </v-flex>
                        </v-flex>
                        <v-divider class="mt-2 mr-3"></v-divider>

                      </v-timeline-item>
                    </v-slide-x-reverse-transition>
                  </v-timeline>
                </v-flex>
              </v-card>
            </v-tab-item>
          <!-- </v-tab-items> -->
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  // import {loaded} from 'vue2-google-maps'
  // import * as VueGoogleMaps from 'vue2-google-maps'
  import mapOptions from '../utils/mapOptions'
  // import {createActionHelpers} from 'vuex-loading'
  import {iconMarkers} from '../utils/staticsRef'
  import {eventsTypeMap} from '../utils/eventsType'
  import * as types from '../store/mutations-types'

  import {inverseGeocode} from '../utils/geocoder'

  import { vehicleStatesMixin } from '../mixins/vehicleStatesMixin.js'
  import { officialZonesMixin } from '../mixins/officialZonesMixin.js'
  // const {startLoading} = createActionHelpers({
  //   moduleName: 'loading'
  // })

  import { inMissionStatesMap } from '../utils/inMissionStates'

  import OfficialZones from '../components/OfficialZones'
  import RoutePlayer from '../components/RoutePlayer'
  import InfoBubblePolygonName from '../components/InfoBubblePolygonName'

  import zoomMapBoundaries from '../utils/zoomMapBoundaries'
  import {agencyBelongsToDeant} from '../utils/clientId'

  /**
   * Componente base para la vista del vehiculo y sus posiciones
   *
   * @author Manuel Ochoa
   */
  export default {
    name: 'app-vehicle-viewer',
    components: {
      OfficialZones,
      RoutePlayer,
      InfoBubblePolygonName
    },
    mixins: [vehicleStatesMixin, officialZonesMixin],
    data() {
      return {
        firefightersDivision: '',
        inMissionStatesMap,
        loadingPlaces: false,
        addressLastPosition: 'Cargando...',
        address: '',
        dialogAllData: true,
        showClearHistoryBtn: false,
        eventsLoaded: false,
        eventsBlocks: [],
        tab: null,
        radioGroupEvents: 'Mostrar eventos',
        eventsRadio: [
          'Mostrar eventos',
          'Mostrar todo'
        ],
        menu: false,
        dates: [],
        mapOptions,
        /**
         * @type {Object} centro del mapa (Medellín)
         */
        center: {
          lat: 6.254790211409118,
          lng: -75.551029793457
        },
        polylineOptions: [],
        polylineOptionsBase: {
          strokeColor: 'black',
          strokeOpacity: 1,
          strokeWeight: 2,
          geodesic: true,
          icons: [{
            icon: {
              path: 3,
              scale: 2,
              fillColor: '#22bf15'
            },
            offset: '0',
            repeat: '100px'
          }]
        },
        /**
         * @type {Object} selectedPosition - Posición seleccionada para un punto en el historial del vehiculo
         */
        selectedPosition: null,
        /**
         * Objecto que va a contener de la información de las posiciones de un vehiculo de forma paginada
         *
         * @type {Object}
         */
        positions: {},
        /**
         * X - Posicion X en el mapa medida en pixeles cuando se le da click a cualquier parte del mapa
         *
         * @type {!number}
         */
        x: 0,
        /**
         * Y - Posicion Y en el mapa medida en pixeles cuando se le da click a cualquier parte del mapa
         *
         * @type {!number}
         */
        y: 0,
        /**
         * Controla la visibilidad del menu tipo popover que funciona para activar los marcadores en el mapa
         *
         * @type {!boolean}
         */
        showMenu: false,
        /**
         * Controla la visibilidad de los marcadores sobre la polilinea.
         *
         * @type {boolean}
         */
        showMarkers: true,
        showMarkersALL: false,
        time1Date1Menu: false,
        time2Date1Menu: false,
        time1Date1: null,
        time2Date1: null,
        time1Date2Menu: false,
        time1Date2: null,
        lastPositionAll: null,
        place: null,
        neighborhood: '',
        quadrant: '',
        commune: '',
        station: '',
        district: '',
        municipality: '',
        showRoutePlayer: false,
        clickedHourTime1Date1Value: null,
        isSetMapListeners: false
      }
    },
    watch: {
      selectedVehicle(newData, oldData) {
        // console.log('WATCH selectedVehicle: ', newData, oldData)
      },
      realTimeVehicleLocation(newData, oldData) {
        // console.log('realTimeVehicleLocation', newData, oldData)
        if (newData === null) return

        const newDataHasLocation = newData.hasOwnProperty('location')
        let newDataIsForSelecetedVehicle = false
        if (newDataHasLocation) newDataIsForSelecetedVehicle = newData.id === this.selectedVehicle.id
        else return

        if (!newDataIsForSelecetedVehicle) return

        if (oldData !== null) {
          const timeTempNew = newData.location.time
          const timeTempOld = oldData.location.time

          const dateTime1 = this.$moment(timeTempNew)
          const dateTime2 = this.$moment(timeTempOld)

          const isInvalidTimeToUpdate = this.$moment(dateTime1).isSameOrBefore(dateTime2)
          if (isInvalidTimeToUpdate) return
          else this.updateSelectedVehicle(newData)
        }

        if (oldData === null) {
          // console.log('WATCH FIRST RTL BEFORE', newData.location, oldData)
          const lat = newData.location.lat
          const lng = newData.location.lng
          setTimeout(() => {
            // console.log('WATCH FIRST RTL AFTER', newData.location, oldData)
            inverseGeocode({lat, lng})
              .then(result => {
                if (result.hasOwnProperty('formatted_address')) {
                  this.addressLastPosition = result.formatted_address
                  // console.log('RESULT THEN INIT 1: ', this.addressLastPosition)
                } else {
                  this.addressLastPosition = result
                  // console.log('RESULT THEN INIT 2: ', this.addressLastPosition)
                }
              })
            // console.log('GEOCODE INIT')
          }, 4000)
        }

        if (newData !== oldData && oldData !== null) {
          // console.log('WATCH RTL Lat', newData.location.lat, oldData.location.lat)
          // console.log('WATCH RTL Lng', newData.location.lng, oldData.location.lng)

          const oldLat = oldData.location.lat
          const oldLng = oldData.location.lng
          const newLat = newData.location.lat
          const newLng = newData.location.lng

          let inverseGeocoder = null

          const matchLat = oldLat === newLat
          const matchLng = oldLng === newLng

          // console.log('matchLat', matchLat)
          // console.log('matchLng', matchLng)

          // matchLat && matchLng ? console.log('SAME LOCATION') : inverseGeocoder = inverseGeocode({lat: newLat, lng: newLng})

          if (matchLat && matchLng) return
          else {
            this.getPlace({lat: newData.location.lat, lng: newData.location.lng})
            inverseGeocoder = inverseGeocode({lat: newLat, lng: newLng})
          }

          if (inverseGeocoder !== null) {
            inverseGeocoder
              .then(result => {
                if (result.hasOwnProperty('formatted_address')) {
                  this.addressLastPosition = result.formatted_address
                  // console.log('RESULT THEN 1: ', this.addressLastPosition)
                } else {
                  this.addressLastPosition = result
                  // console.log('RESULT THEN 2: ', this.addressLastPosition)
                }
              })
          }
        }
      },
      /**
       * Actualiza el nuevo valor de las posiciones de un vehiculo cada vez que hay un cambio via filtros
       *
       * Ademas centra el mapa
       *
       * @param newVal
       * @returns {Promise<void>}
       */
      async positions(newVal) {
        if ('data' in newVal && newVal.data.length > 0) {
          // await loaded
          let bounds = new google.maps.LatLngBounds()
          newVal.data.map(position => {
            let googlePos = new google.maps.LatLng(position.lat, position.lng)
            bounds.extend(googlePos)
          })
          this.$nextTick(() => {
            const area = zoomMapBoundaries(bounds)
            if (area > 100000) {
              // console.log('Area > 100000')
              'VehicleViewerMap' in this.$refs && this.$refs.VehicleViewerMap.fitBounds(bounds)
            } else {
              // const extraPadding = area < 20000 ? 440 : 300
              const extraPadding = 100
              // console.log('Area <= 100000')
              'VehicleViewerMap' in this.$refs && this.$refs.VehicleViewerMap.fitBounds(bounds, extraPadding)
              this.mapOptions.zoom = 17
            }
          })
        }
      },
      time2Date1(newValue) {
        if (newValue !== null) {
          if (newValue === this.time1Date1) {
            const dateTime1 = this.$moment(`${this.dates[0]} ${this.time1Date1}`)
            const dateTime2 = this.$moment(dateTime1).add(1, 'minutes')
            const isDifferentDate = this.$moment(dateTime2).isAfter(dateTime1, 'day')
            // console.log('isDifferentDate: ', isDifferentDate)
            if (isDifferentDate) {
              const date2 = this.$moment(dateTime2).format('YYYY-MM-DD')
              this.dates[1] = date2
            } else {
              const tempTime2 = this.$moment(dateTime2).format('HH:mm')
              // console.log('temp1', tempTime2)
              this.time2Date1 = tempTime2
            }
          }
        }
      },
      dates(newData, oldData) {
        // console.log('WATCH dates NEW DATA', newData)
        // console.log('WATCH dates OLD DATA', oldData)
        if (oldData.length === 2 && newData.length === 1) {
          this.time1Date1 = null
          this.time1Date2 = null
          // console.log('DATES:', this.dates)
        }
      },
      showLoadingVehicleData(newValue) {
        if (!newValue && this.allDataLoading && !this.isSetMapListeners) {
          this.isSetMapListeners = true
          this.setMapListeners()
        }
      },
      allDataLoading(newValue) {
        if (newValue && !this.showLoadingVehicleData && !this.isSetMapListeners) {
          this.isSetMapListeners = true
          this.setMapListeners()
        }
      }
    },
    computed: {
      ...mapGetters({
        selectedVehicle: 'getSelectedVehicle',
        mapZoneMode: 'auth/mapZoneMode'
      }),
      ...mapGetters([
        'lastPositionsInit',
        'showPointsSection',
        // 'showPointsMessage',
        'superParents',
        'vehicleTypes',
        'agenciesMap',
        'agenciesBase',
        'showLoadingVehicleData',
        'realTimeVehicleLocation'
      ]),
      // infoStateVehicle() {
      //   const stoppedTime = this.realTimeVehicleLocation.stoppedTime
      //   const speed = this.realTimeVehicleLocation.location.speed
      //   if (speed >= 5) return 0
      //   else {
      //     if (stoppedTime < 240) return `${stoppedTime} minutos`
      //     else {
      //       const hours = Math.floor(stoppedTime / 60)
      //       const minutes = stoppedTime % 60
      //       return `${hours} horas ${minutes} minutos`
      //     }
      //   }
      // },
      gobernacionZones() {
        if (this.mapZoneMode === 'gobernacion') return true
        const vehicle = this.selectedVehicle
        if (!vehicle || vehicle.agencyId === null || vehicle.agencyId === undefined) return false
        return agencyBelongsToDeant(vehicle.agencyId, this.agenciesBase)
      },
      allDataLoading() {
        let value = false
        if (this.lastPositionsInit.length !== 0 && this.agenciesMap !== null && this.vehicleTypes !== null) {
          value = true
          if (!this.selectedVehicle.hasOwnProperty('stoppedTimeSinceV2')) {
            // console.log('allDataLoading', this.selectedVehicle, this.lastPositionsInit, value, this.$route.params.vehicle_id)
            const selectedVehicleTemp = this.lastPositionsInit.find(item => item.id === this.selectedVehicle.id)
            // console.log('******************** selectedVehicleTemp allDataLoading', selectedVehicleTemp)
            if (selectedVehicleTemp !== undefined) this.addST2SelectedVehicle(selectedVehicleTemp.stoppedTimeSinceV2)
          }
        }

        // console.log('ALL DATA LOADING: ', value, this.lastPositionsInit.length, this.agenciesMap, this.vehicleTypes)
        return value
      },
      gpsValid() {
        let value = ''
        if (this.selectedVehicle !== null) {
          const sourceData = this.selectedVehicle.location.hasOwnProperty('GPSValid')
          if (sourceData) value = this.selectedVehicle.location.GPSValid ? 'Con Señal' : 'Sin Señal'
          else value = this.selectedVehicle.location.metadata.GPSValid ? 'Con Señal' : 'Sin Señal'
        }
        return value
      },
      filteredEvents() {
        let events = []
        // console.log('filteredEvents : ', this.positions)
        if (this.positions.hasOwnProperty('data')) events = this.positions.data.filter(item => item.eventType === 53)
        // console.log('EVENTS : ', events)
        return events
      },
      allowRequestHistory() {
        let result = true
        if (this.dates.length === 1) {
          result = this.time1Date1 === null && this.time2Date1 === null
        } else if (this.dates.length === 2) {
          result = this.time1Date2 === null
        }
        return result
      }
    },
    methods: {
      ...mapActions([
        'clearAllOfficialPolygons',
        'saveOfficialZonesHome',
        'addST2SelectedVehicle',
        'updateSelectedVehicle',
        'fetchVehicleById',
        'filterPositionsByVehicleId',
        'loadMorePointsAction',
        'getPlaceAction'
      ]),
      blockSelected(e) {
        // console.log('BLOCK SELECTED :', e, this.$refs['polyLine' + String(e)])
        // console.log('BLOCK SELECTED OPTIONS :', e, this.$refs['polyLine' + String(e)][0].options)
        // console.log('BLOCK SELECTED $OPTIONS :', e, this.$refs['polyLine' + String(e)][0].$options.propsData.options)
        this.polylineOptions[e].strokeColor = 'blue'
      },
      showMarkersChange(value) {
        if (value === 'Mostrar eventos') {
          this.showMarkers = true
          this.showMarkersALL = false
        } else {
          this.showMarkers = false
          this.showMarkersALL = true
        }
      },
      eventTypeName(key) {
        const eventTypeName = eventsTypeMap.get(key)
        return eventTypeName
      },
      markerEvent(selectedPosition) {
        if (this.selectedVehicle === null || !this.allDataLoading) return null

        const vehicleTypeResult = this.vehicleTypes.get(this.selectedVehicle.vehicleType)
        let vehicleType = 'V'
        if (vehicleTypeResult === 'MOTOCICLETA') vehicleType = 'M'

        let vehicleState = 'OFF'
        if (selectedPosition !== null) {
          const ignitionStatus = selectedPosition.metadata.ignitionStatus
          if (ignitionStatus === 1) vehicleState = 'ON'
        }

        let superAgency = '10'
        if (this.selectedVehicle.agencyId !== null && this.selectedVehicle.agencyId !== undefined && this.agenciesMap) {
          const agencyEntry = this.agenciesMap.get(this.selectedVehicle.agencyId)
          if (agencyEntry) {
            const counter = this.superParents.get(agencyEntry.superParentId)
            if (counter) superAgency = String(((counter - 1) % 10) + 1)
          }
        }

        const key = `MARKER_${vehicleType}_A_${superAgency}_${vehicleState}`

        return iconMarkers[key] || iconMarkers[`MARKER_${vehicleType}_A_10_${vehicleState}`] || iconMarkers.MARKER_V_A_10_OFF
      },
      marker() {
        if (this.selectedVehicle === null || !this.allDataLoading) return null

        if (!this.selectedVehicle.hasOwnProperty('location')) return null

        const vehicleTypeResult = this.vehicleTypes.get(this.selectedVehicle.vehicleType)
        let vehicleType = 'V'
        if (vehicleTypeResult === 'MOTOCICLETA') vehicleType = 'M'

        // const eventType = this.selectedVehicle.location.eventType
        // let vehicleState = 'ON'
        // if (eventType === 11 || eventType === 53) vehicleState = 'OFF'
        const ignitionStatus = this.selectedVehicle.location.hasOwnProperty('ignitionStatus')
          ? this.selectedVehicle.location.ignitionStatus
          : this.selectedVehicle.location.metadata.ignitionStatus
        let vehicleState = 'OFF'
        if (ignitionStatus === 1) vehicleState = 'ON'

        let superAgency = '10'
        if (this.selectedVehicle.agencyId !== null && this.selectedVehicle.agencyId !== undefined && this.agenciesMap) {
          const agencyEntry = this.agenciesMap.get(this.selectedVehicle.agencyId)
          if (agencyEntry) {
            const counter = this.superParents.get(agencyEntry.superParentId)
            if (counter) superAgency = String(((counter - 1) % 10) + 1)
          }
        }

        const key = `MARKER_${vehicleType}_A_${superAgency}_${vehicleState}`
        // console.log('KEY', key)

        return iconMarkers[key] || iconMarkers[`MARKER_${vehicleType}_A_10_${vehicleState}`] || iconMarkers.MARKER_V_A_10_OFF
      },
      /**
       * Trae la información del vehiculo a analizar, y guarda sus posiciones, ademas centra el mapa segundo las posiciones que hayan.
       *
       * @returns {Promise<void>}
       */
      async fetchVehicleData() {
        try {
          this.$store.commit(types.SHOW_POINTS, false)
          this.selectedPosition = null
          this.positions = {}
          this.eventsBlocks = []
          this.dates = []
          this.time1Date1Menu = false
          this.time2Date1Menu = false
          this.time1Date1 = null
          this.time2Date1 = null
          this.time1Date2Menu = false
          this.time1Date2 = null
          this.eventsLoaded = false
          this.showClearHistoryBtn = false
          await this.fetchVehicleById(this.$route.params.vehicle_id)
          // console.log('SELECTED VEHICLE : ', this.selectedVehicle)

          const selectedVehicleTemp = this.lastPositionsInit.find(item => item.id === this.$route.params.vehicle_id)
          // console.log('******************** selectedVehicleTemp', selectedVehicleTemp)
          if (selectedVehicleTemp !== undefined) this.addST2SelectedVehicle(selectedVehicleTemp.stoppedTimeSinceV2)

          this.center = {
            lat: this.selectedVehicle.lastPosition.lat,
            lng: this.selectedVehicle.lastPosition.lng
          }
          this.mapOptions.zoom = 15
          this.lastPositionAll = {
            lat: this.selectedVehicle.lastPosition.lat,
            lng: this.selectedVehicle.lastPosition.lng
          }
          this.getPlace({lat: this.lastPositionAll.lat, lng: this.lastPositionAll.lng})
        } catch (e) {
          console.error(e)
        }
      },
      /**
       * Función de ayuda para el selector de fecha donde inicialmente solo se puede escoger los días antes de hoy; y solo máximo dos días (48 horas) con respecto al primer día seleccionado.
       *
       * @param {string} date
       * @return {boolean}
       */
      allowedDates(date) {
        let today = this.$moment.now()
        let datesResult = this.$moment(date).isBefore(today)
        today = this.$moment(today).format('YYYY-MM-DD')

        if (this.dates.length === 1) {
          if (today === this.dates[0]) {
            datesResult = date === this.dates[0]
          } else {
            const dayAfter = this.$moment(this.dates[0]).add(1, 'days').format('YYYY-MM-DD')
            datesResult = date === this.dates[0] || date === dayAfter
          }
        } else if (this.dates.length === 2) {
          datesResult = date === this.dates[0] || date === this.dates[1]
        }

        return datesResult
      },
      /**
       * Metodo que limpia los filtros de la vista de vehiculos
       * @return {void}
       */
      handleClearFilters() {
        this.closeRoutePlayer()
        this.fetchVehicleData()
      },
      async handleClickMarker({pixel}, position, index) {
        this.showMenu = true
        this.selectedPosition = position
        this.x = pixel.x
        this.y = pixel.y

        // console.log('POSITION:', this.selectedPosition)
      },
      /**
       * Metodo que carga 50 posiciones más del vehículo segun el filtro.
       *
       * @return {void}
       */
      async loadMorePositions() {
        try {
          const _link = this.positions.links.next
          const {data: positions} = await this.loadMorePointsAction(_link)
          this.positions.data.push(...positions.data)
          this.positions = {
            ...this.positions,
            links: positions.links,
            meta: positions.meta
          }
          // console.log('LOAD MORE POSITIONS : ', positions)
          this.eventsBlocks.push(positions.data)
          this.polylineOptions.push(this.polylineOptionsBase)
        } catch (error) {
          console.error(error)
        }
      },
      async recordOfVehicleEvents() {
        try {
          const data = {
            id: this.selectedVehicle.id,
            date1: this.dates[0],
            time1Date1: this.time1Date1,
            time2Date1: this.time2Date1,
            date2: this.dates[1] ? this.dates[1] : null,
            time1Date2: this.time1Date2
          }
          // this.positions = await this.filterPositionsByVehicleId(data)
          // const {data: positions} = await this.filterPositionsByVehicleId(data)
          const result = await this.filterPositionsByVehicleId(data)
          this.positions = result
          this.eventsLoaded = true
          this.showClearHistoryBtn = true
          // console.log('RECORD OF VEHICLES EVENTS : ', result)
          this.eventsBlocks.push(result.data)
        } finally {
          // console.log('POSITIONS HIST', this.positions)
          this.selectedPosition = null
        }
      },
      zoneName(place, type) {
        const match = place.filter(el => el.type === type)
        if (match.length > 0 && match[0].name) return match[0].name
        return 'NA'
      },
      async getPlace(value) {
        this.loadingPlaces = true
        this.firefightersDivision = ''
        this.municipality = ''
        this.neighborhood = ''
        this.quadrant = ''
        this.station = ''
        this.district = ''
        this.commune = ''

        if (this.gobernacionZones) {
          try {
            const [zones, municipalities] = await Promise.all([
              this.getPlaceAction({
                lat: value.lat,
                lng: value.lng,
                clientId: 2,
                type: 'quadrant,policeStation'
              }),
              this.getPlaceAction({
                lat: value.lat,
                lng: value.lng,
                clientId: 1,
                type: 'municipality'
              })
            ])
            this.place = zones.concat(municipalities)
            this.quadrant = this.zoneName(this.place, 'quadrant')
            this.station = this.zoneName(this.place, 'policeStation')
            this.municipality = this.zoneName(this.place, 'municipality')
          } finally {
            this.loadingPlaces = false
          }
          return
        }

        this.place = await this.getPlaceAction({...value, clientId: 1})

        this.loadingPlaces = false

        // console.log('PLACE', this.place)
        const municipality = this.place.filter(el => el.type === 'municipality')
        this.municipality = municipality[0].name

        if (['Medellín', 'Medellin', 'medellín', 'medellin'].includes(this.municipality.trim())) {
          const neighborhood = this.place.filter(el => el.type === 'neighborhood')
          this.neighborhood = neighborhood !== undefined
            && neighborhood.length > 0
            && neighborhood[0].hasOwnProperty('name')
            ? neighborhood[0].name
            : 'NA'

          const quadrant = this.place.filter(el => el.type === 'quadrant')
          this.quadrant = quadrant !== undefined && quadrant.length > 0 ? quadrant[0].name : 'NA'

          const station = this.place.filter(el => el.type === 'policeStation')
          this.station = station !== undefined && station.length > 0 ? station[0].name : 'NA'

          const district = this.place.filter(el => el.type === 'policeDistrict')
          this.district = district !== undefined && district.length > 0 ? district[0].name : 'NA'

          const commune = this.place.filter(el => el.type === 'commune')
          this.commune = commune !== undefined && commune.length > 0 ? commune[0].name : 'NA'

          const firefightersDivision = this.place.filter(el => el.type === 'firefightersDivision')
          this.firefightersDivision = firefightersDivision !== undefined && firefightersDivision.length > 0
            ? firefightersDivision[0].name
            : 'NA'
        } else {
          this.firefightersDivision = 'NA'
          this.neighborhood = 'NA'
          this.quadrant = 'NA'
          this.commune = 'NA'
          this.station = 'NA'
          this.district = 'NA'
        }
      },
      openRoutePlayer() {
        this.showMarkers = false
        this.radioGroupEvents = 'Mostrar eventos'
        this.showMarkersChange('Mostrar eventos')
        this.showRoutePlayer = true
      },
      closeRoutePlayer() {
        this.selectedPosition = null
        this.radioGroupEvents = 'Mostrar eventos'
        this.showMarkersChange('Mostrar eventos')
        this.showRoutePlayer = false
      },
      processCurrentEventFromPlayer(data) {
        this.showMarkers = false
        this.selectedPosition = data
      },
      allowedHoursTime2Date1(value) {
        // console.log('allowedHoursTime2Date1', value)
        // console.log('Time1 Date1:', this.time1Date1)
        let allowedHour = false
        const timeTemp = this.time1Date1.split(':')
        allowedHour = Number(timeTemp[0]) <= value
        return allowedHour
      },
      allowedMinutesTime2Date1(value) {
        // console.log('allowedMinutesTime2Date1', value)
        // console.log('Time1 Date1:', this.time1Date1)
        // console.log('Time2 Date1:', this.time2Date1)
        const startHour = this.time1Date1.split(':')
        // console.log('startHour', startHour)
        const selectedHour = this.time2Date1.split(':')
        // console.log('selectedHour', selectedHour)
        if (Number(startHour[0]) === Number(selectedHour[0])) {
          if (value > Number(startHour[1])) return true
          else return false
        } else return true
      },
      saveTime1Date1() {
        this.$refs.time1Date1Menu.save(this.time1Date1)
        const dateTime1 = this.$moment(`${this.dates[0]} ${this.time1Date1}`)
        const dateTime2 = this.$moment(dateTime1).add(1, 'minutes')
        // const temp1 = this.$moment(dateTime2).format('HH:mm')
        const isDifferentDate = this.$moment(dateTime2).isAfter(dateTime1, 'day')
        // console.log('isDifferentDate: ', isDifferentDate)
        if (isDifferentDate) {
          const date2 = this.$moment(dateTime2).format('YYYY-MM-DD')
          this.dates[1] = date2
        } else {
          const tempTime2 = this.$moment(dateTime2).format('HH:mm')
          // console.log('temp1', tempTime2)
          this.time2Date1 = tempTime2
        }
        // console.log('temp1', temp1)
        // this.time2Date1 = temp1
      },
      // changesTime2Date1(value) {
      //   // console.log('changesTime2Date1', value)
      // },
      // changesInDates(value) {
      //   // console.log('changesInDates', value, value.length)
      // },
      allowedMinutesTime1Date1(value) {
        // console.log('clickedHourTime1Date1Value:', this.clickedHourTime1Date1Value)
        // console.log('allowedMinutesTime1Date1', value)
        let result = true
        if (this.clickedHourTime1Date1Value === 23) {
          result = value < 59
        }
        return result
      },
      clickedHourTime1Date1(value) {
        // console.log('clickedHourTime1Date1', value)
        this.clickedHourTime1Date1Value = value
        this.time1Date1 = value < 10 ? `0${String(value)}:00` : `${String(value)}:00`
      },
      setMapListeners() {
        setTimeout(() => {
          this.$refs.VehicleViewerMap.$mapPromise.then((map) => {
            map.addListener('zoom_changed', () => {
              this.showOfficialFenceName = false
            })
            map.addListener('drag', () => {
              this.showOfficialFenceName = false
            })
          })
        }, 2000)
      }
    },
    async created() {
      this.fetchVehicleData()
      await this.saveOfficialZonesHome()
      this.clearAllOfficialPolygons()
    },
    mounted() {
      // console.log('MOUNTED: ', this.selectedVehicle)

      if (this.selectedVehicle !== null) {
        const lat = this.selectedVehicle.location.lat
        const lng = this.selectedVehicle.location.lng
        inverseGeocode({lat, lng})
          .then(result => {
            if (result.hasOwnProperty('formatted_address')) {
              this.addressLastPosition = result.formatted_address
              // console.log('RESULT THEN MOUNTED 1: ', this.addressLastPosition)
            } else {
              this.addressLastPosition = result
              // console.log('RESULT THEN MOUNTED 2: ', this.addressLastPosition)
            }
          })
      }
    }
  }
</script>

<style lang="stylus" scoped>
p
  margin-bottom 5px

h3
  font-size 21px
  font-weight 400
  color #424242

h4
  font-size 18px
  font-weight 500

h5
  font-size 18px
  font-weight 400
  color white

h6
  font-size 14px
  font-weight 500
  color white

.h7
  font-size 11px
  font-weight 500
  color white

b
  color grey

.clear-poly-style
  position relative
  top 0px
  left 805px
  font-size 12px
  font-weight 600
  width 200px
  // height: 30px;

.btn-absolute
  position absolute
  top 10px
  left 10px
  z-index 5

.icon-address
  min-width 40px
  max-width 40px

.subtitle-1
  color grey

.stopped-time-style
  font-size 10px
  font-weight 400

.little-text
  font-size 11px
  font-weight 400
  color #616161

.style-date-h
  font-weight 600
  font-size 16px

.container-date-1
  background-color #00897B
  border-radius 30px

.container-date-2
  background-color #E53935
  border-radius 30px

.margin-bottom-1
  margin-bottom 200px

.container-map
  width calc(100vw - 470px)

.container-side
  width 415px
  height calc(100vh - 48px)
  overflow-y scroll

.background-1
  background-color #212121

.h3-alt
  color white

.expansion-panel .expansion-panel__container
  background-color #212121 !important

.margin-1
  margin-left -10px

.margin-2
  margin-top -2px
  margin-bottom -2px

.AppVehicleViewer_map
  width 100%
  height 95vh

.player-absolute
  position absolute
  top calc(100vh - 190px)
  left calc(50vw - 491px)
  z-index 5

.info-absolute
  position absolute
  // top 82px
  left 18px
  z-index 5
</style>



// WEBPACK FOOTER //
// src/components/AppVehicleViewer.vue